import React from 'react';
import { Footer } from '../../components/footer/Footer';
import { GetStarted } from '../../components/getStarted/GetStarted';
import { Header } from '../../components/header/Header';
import { LearnMoreAboutUs } from '../../components/learnMoreAboutUs/LearnMoreAboutUs';
import { LocationSection } from '../../components/locationSection/LocationSection';
import { Makes } from '../../components/makes/Makes';
import { NavBar } from '../../components/navbar/NavBar';

export const AboutUs = () => {
  return (
    <div style={{ height: '100vh', backgroundColor: '#ffffff' }}>
      <NavBar />

      <LearnMoreAboutUs />

      <Header />

      <Makes />

      {/* <LearnMoreAboutUs /> */}

      <LocationSection />

      <GetStarted />

      <Footer />
    </div>
  );
};
